<template>
  <div>
    <CardedSectionHeader
      icon="mdi-form-select"
      label="Category Preview"
      id="admin_edit_category_category_details"
    ></CardedSectionHeader>
    <div class="pt-4 pb-4 white text-right pr-8">
      <v-btn
        @click="$router.go(-1)"
        small
        rounded
        class="mr-4"
        outlined
        color="default"
      >
        <v-icon left>mdi-cancel</v-icon> Cancel Edit
      </v-btn>
      <v-btn
        :to="'/admin/categories/view/' + $route.params.id + '/delete'"
        small
        rounded
        class="mr-4"
        outlined
        color="red"
      >
        <v-icon left>mdi-trash-can</v-icon> Remove Category
      </v-btn>
    </div>
    <CardedDisplay>
      <ViewHeader
        :title="category.name"
        :icon="category.icon"
        :img_src="category.thumb_nail"
        :facts="view_header_facts"
        :description="category.description"
      ></ViewHeader>
    </CardedDisplay>
    <CardedSectionHeader
      icon="mdi-form-select"
      label="Category Edit Form "
      id="admin_edit_category_form"
    ></CardedSectionHeader>
    <AdminCategoriesAdd
      ref="edit_form_ref"
      :is_editing="true"
      :is_loading="is_loading"
      @on-success-edit="on_success_edit"
      @on-show-loader="$emit('on-show-loader')"
      @on-hide-loader="$emit('on-hide-loader')"
    >
    </AdminCategoriesAdd>
  </div>
</template>

<script>
import CardedSectionHeader from "../../../components/CardedSectionHeader";
import CardedDisplay from "../../../components/CardedDisplay";
import AdminCategoriesAdd from "./AdminCategoriesAdd";
import ViewHeader from "../../../components/ViewHeader";
import ServerClient from "../../../lib/ServerClient";
import Utils from "../../../lib/Utils";

export default {
  name: "AdminCategoriesEdit",
  components: {
    CardedSectionHeader,
    CardedDisplay,
    ViewHeader,
    AdminCategoriesAdd,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      category: Utils.get_default_category(),
    };
  },
  computed: {
    view_header_facts() {
      var facts = [
        {
          text: "Top Category:",
          val: (parseInt(this.category.is_top_category == 1)) ? "Yes" : "No",
        },
        { text: "Top Category Level:", val: this.category.top_category_level },
      ];
      return facts;
    },
  },
  methods: {
    load_category() {
      this.$emit("on-show-loader");
      ServerClient.Categories.get_category(
        {
          id: this.$route.params.id,
          is_edit: true,
        },
        (res) => {
          this.$emit("on-hide-loader");
          console.log("category to be edited ", res);
          this.category = res;
          this.$refs.edit_form_ref.init_editing_form(this.category);
        },
        (errors) => {
          this.$emit("on-hide-loader");
          console.log(
            "Errors while loading category details on admin edit category ",
            errors
          );
        }
      );
    },
    on_success_edit() {
      this.load_category();
    },
  },
  mounted() {
    var category_id = this.$route.params.id;
    this.$emit("set-page-attributes", {
      title: "Edit Category",
      crumps: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin",
        },
        {
          text: "Categories",
          disabled: false,
          href: "/admin/categories",
        },
        {
          text: "List",
          disabled: false,
          href: "/admin/categories/list",
        },
        {
          text: "View",
          disabled: false,
          href: "/admin/categories/view/" + category_id,
        },
        {
          text: "Edit",
          disabled: true,
          href: "/admin/categories/view/" + category_id + "/edit",
        },
      ],
    });
    this.load_category();
  },
};
</script>